export default __webpack_public_path__ + "static/media/otherImg.e60410cf.png";